import request from './index'

export function getOrderList(params) {
  return request({
    url: '/order/list',
    method: 'get',
    params
  })
}

export function getOrderDetail(id) {
  return request({
    url: '/order/detail/' + id,
    method: 'get'
  })
}

export function approveOrder(id) {
  return request({
    url: '/order/' + id + '/approve',
    method: 'post'
  })
}

export function signOrder(id) {
  return request({
    url: '/order/' + id + '/sign',
    method: 'post'
  })
}

export function deliverOrder(id, data) {
  return request({
    url: '/order/' + id + '/deliver',
    method: 'post',
    data
  })
}

export function receiveOrder(id) {
  return request({
    url: '/order/' + id + '/receive',
    method: 'post'
  })
}

export function finishOrder(id) {
  return request({
    url: '/order/' + id + '/finish',
    method: 'post'
  })
}

export function cancelOrder(id, reason) {
  return request({
    url: '/order/' + id + '/cancel',
    method: 'post',
    data: { reason }
  })
}

export function riskConsult(id, consultRiskTypes) {
  return request({
    url: '/order/' + id + '/risk-consult',
    method: 'post',
    data: consultRiskTypes ? { consultRiskTypes } : {}
  })
}

export function legalConsult(id) {
  return request({
    url: '/order/' + id + '/legal-consult',
    method: 'post',
    params: { source: 'ADMIN' }
  })
}

export function creditConsult(id) {
  return request({
    url: '/order/' + id + '/credit-consult',
    method: 'post',
    params: { source: 'ADMIN' }
  })
}

export function zuxianzhiConsult(id) {
  return request({
    url: '/order/' + id + '/zuxianzhi-consult',
    method: 'post',
    params: { source: 'ADMIN' }
  })
}

export function createContract(id) {
  return request({
    url: '/order/' + id + '/create-contract',
    method: 'post',
    params: { source: 'ADMIN' }
  })
}

export function listContracts(id) {
  return request({
    url: '/order/' + id + '/contracts',
    method: 'get'
  })
}

export function listRiskConsult(id) {
  return request({
    url: '/order/' + id + '/risk-consult/list',
    method: 'get'
  })
}

export function getOrderStatusCounts() {
  return request({
    url: '/order/status-counts',
    method: 'get'
  })
}

export function getDashboardStats() {
  return request({
    url: '/order/dashboard-stats',
    method: 'get'
  })
}

// ============ 扣款相关 ============
export function getOrderInstallments(id) {
  return request({
    url: '/order/' + id + '/installments',
    method: 'get'
  })
}

export function getDeductionRecords(id, installmentNo) {
  return request({
    url: '/order/' + id + '/deduction-records',
    method: 'get',
    params: installmentNo ? { installmentNo } : {}
  })
}

export function deductInstallment(id, data) {
  return request({
    url: '/order/' + id + '/deduct',
    method: 'post',
    data
  })
}

export function offlinePay(id, data) {
  return request({
    url: '/order/' + id + '/offline-pay',
    method: 'post',
    data
  })
}

export function completeOrder(id) {
  return request({
    url: '/order/' + id + '/complete',
    method: 'post'
  })
}

export function sendReturnOrder(id) {
  return request({
    url: '/order/' + id + '/send-return',
    method: 'post'
  })
}

export function receiveReturnOrder(id) {
  return request({
    url: '/order/' + id + '/receive-return',
    method: 'post'
  })
}

export function alipayQueryOrder(id) {
  return request({
    url: '/order/' + id + '/alipay-query',
    method: 'get'
  })
}

export function listOrderLogs(id) {
  return request({
    url: '/order/' + id + '/logs',
    method: 'get'
  })
}

export function exportBill(params) {
  return request({
    url: '/order/bill/export',
    method: 'post',
    data: params
  })
}

export function getDailyStats() {
  return request({
    url: '/order/daily-stats',
    method: 'get'
  })
}

export function getMonthlySettlement(params) {
  return request({
    url: '/order/monthly-settlement',
    method: 'get',
    params
  })
}

export function getMonthlySettlementOrders(params) {
  return request({
    url: '/order/monthly-settlement/orders',
    method: 'get',
    params
  })
}

// ============ 赔付相关 ============
export function createCompensation(data) {
  return request({
    url: '/aftersale/compensation/create',
    method: 'post',
    data
  })
}

export function approveCompensation(id, data) {
  return request({
    url: '/aftersale/' + id + '/compensation/approve',
    method: 'post',
    data
  })
}

export function deductCompensation(id) {
  return request({
    url: '/aftersale/' + id + '/compensation/deduct',
    method: 'post'
  })
}

export function closeCompensation(id) {
  return request({
    url: '/aftersale/' + id + '/compensation/close',
    method: 'post'
  })
}

export function getCompensationList(params) {
  return request({
    url: '/aftersale/compensation/list',
    method: 'get',
    params
  })
}

// ============ 买断相关 ============
export function createBuyout(orderId) {
  return request({
    url: '/order/' + orderId + '/buyout',
    method: 'post'
  })
}

export function payBuyout(buyoutId) {
  return request({
    url: '/buyout/' + buyoutId + '/pay',
    method: 'post'
  })
}

export function getBuyout(orderId) {
  return request({
    url: '/order/' + orderId + '/buyout',
    method: 'get'
  })
}

export function getBuyoutList(orderId) {
  return request({
    url: '/order/' + orderId + '/buyout/list',
    method: 'get'
  })
}

// ============ 续租相关 ============
export function renewOrder(orderId, data) {
  return request({
    url: '/order/' + orderId + '/renew',
    method: 'post',
    data
  })
}

// ============ 合同下载 ============
export function downloadContract(contractId) {
  return request({
    url: '/contract/' + contractId + '/download',
    method: 'get',
    responseType: 'blob'
  })
}

export function getContractDetail(contractId) {
  return request({
    url: '/contract/' + contractId,
    method: 'get'
  })
}

// 重新获取合同签署链接
export function refreshContractSignUrl(orderId, contractId) {
  return request({
    url: '/order/' + orderId + '/contract/' + contractId + '/refresh-sign-url',
    method: 'post'
  })
}

// 同步合同签署状态
export function syncContractSignStatus(orderId, contractId) {
  return request({
    url: '/order/' + orderId + '/contract/' + contractId + '/sync-status',
    method: 'post'
  })
}

// ============ e签宝合同同步 ============
export function syncEsignStatus() {
  return request({
    url: '/order/sync-esign-status',
    method: 'post',
    timeout: 120000,
    _noGlobalLoading: true,
  })
}

export function listZxzReports(id) {
  return request({
    url: '/order/' + id + '/zxz-report/list',
    method: 'get'
  })
}
